<script>
import {cloneDeep} from 'lodash'
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
    name: 'BidActivityModal',
    props: {
        modalTitle: String,
        bidActivities: {
            type: Array,
            default: () => []
        },
        showAct: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        Multiselect,
        DatePicker,
        MaskedInput
    },
    data(){
        return {
            submitted: false,
            activity: {
                id: null,
                prId: null,
                bidActivityId: null,
                bidActivity: null,
                schedule: null,
                notes: null,
                mode: null,
                location: null,
                onlineLink: null,
                meetingNumber: null,
                meetingPassword: null,
                preEventNotification: null
            },
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: false,
            }),
            notify: {
                time: '1',
                options: 'hour'
            }
        }
    },
    validations: {
        activity: {
            bidActivityId: {required},
            schedule: {required},
            mode: {required},
        },
        notify: {
            time: {required},
            options: {required},
        }
    },
    methods: {
        updateData(data){
            this.$v.$reset();
            console.log(data)
            this.activity = cloneDeep(data);
        },
        selectBidActivity(x){
            this.activity.bidActivityId = x.id;
        },
        onSubmitActivity(){
            this.submitted = true;
            this.$v.activity.$touch();
            this.$v.notify.$touch();
            if(this.$v.activity.$invalid || this.$v.notify.$invalid){
                return;
            }
            let sched = new Date(this.activity.schedule);
            if(this.notify.options == 'day'){
                sched.setDate(sched.getDate() - this.notify.time);
                this.activity.preEventNotification = sched;
            }else if(this.notify.options == 'hour'){
                sched.setHours(sched.getHours() - this.notify.time);
                this.activity.preEventNotification = sched;
            }else if(this.notify.options == 'minute'){
                sched.setMinutes(sched.getMinutes() - this.notify.time);
                this.activity.preEventNotification = sched;
            }else{
                this.activity.preEventNotification = this.activity.schedule
            }
            this.$emit('dropData', this.activity);
        }
    }
}
</script>
<template>
  <b-modal
        id="activity-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="onSubmitActivity" class="needs-validation">
            <p class="mb-3 font-size-16" v-if="activity && activity.bidActivity"><i>{{activity.bidActivity.activityName}}</i></p>
            <div class="mb-3" v-if="showAct">
                <label for="title">Bid Activity </label>
                <multiselect
                    v-model="activity.bidActivity"
                    :options="bidActivities"
                    label="activityName"
                    @select="selectBidActivity"
                    track-by="id"
                    value="id"
                    deselect-label=""
                    select-label=""
                    :allow-empty="false"
                    :class="{ 'is-invalid': $v.activity.bidActivityId.$error}"
                />
                <div
                    v-if="submitted && $v.activity.bidActivityId.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.activity.bidActivityId.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="title">Schedule </label>
                <date-picker
                    v-model="activity.schedule"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Schedule..."
                    type="datetime"
                    format="MMM D YYYY hh:mm A"
                    :time-picker-options="{start: '00:00', step:'00:30' , end: '23:30', format: 'hh:mm A'}"
                    :class="{
                        'is-invalid':
                            submitted && $v.activity.schedule.$error,
                    }"
                ></date-picker>
                <div
                    v-if="submitted && $v.activity.schedule.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.activity.schedule.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="title">Mode </label>
                <select 
                    class="form-select" 
                    v-model="activity.mode" 
                    :class="{'is-invalid': submitted && $v.activity.mode.$error}"
                >
                    <option></option>
                    <option>Online</option>
                    <option>Face to Face</option>
                    <option>Hybrid</option>
                </select>
                <div
                    v-if="submitted && $v.activity.mode.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.activity.mode.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="location">Location</label>
                <input type="text" class="form form-control" v-model="activity.location">
            </div>
            <div v-if="activity.mode !== 'Face to Face'">
                <div class="mb-3">
                    <label for="link">Online Link</label>
                    <textarea 
                        autocomplete="off"
                        rows="1" 
                        class="form form-control" 
                        v-model="activity.onlineLink"
                        placeholder="Enter Link"
                    ></textarea>
                </div>
                <div class="mb-3">
                    <label for="link">Meeting Number</label>
                    <input type="text" class="form form-control" v-model="activity.meetingNumber">
                </div>
                <div class="mb-3">
                    <label for="link">Meeting Password</label>
                    <input type="text" class="form form-control" v-model="activity.meetingPassword">
                </div>
            </div>
            <div class="form-check form-checkbox-outline form-check-success mb-3">
                <input
                    type="checkbox"
                    :id="`setReminder`"
                    v-model="activity.withNotification"
                    class="form-check-input"
                />
                <label
                    :for="`setReminder`"
                    class="form-check-label"
                >
                    Set Reminder
                </label>
            </div>
            <div class="mb-3 d-flex align-items-center justify-content-center" v-if="activity.withNotification">
                <p class="mb-0 me-2 no-wrap">Notify me</p>
                <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="notify.time"
                    placeholder="1"
                    class="form-control me-1 text-center"
                    :mask="currencyMask"
                    :class="{'is-invalid': submitted && $v.notify.time.$error}"
                    style="width:90px;"
                >
                </masked-input>
                <select 
                    class="form-select" 
                    v-model="notify.options" 
                    :class="{'is-invalid': submitted && $v.notify.options.$error}"
                    style="width:120px;"
                >
                    <option value="day">Day(s)</option>
                    <option value="hour">Hour(s)</option>
                    <option value="minute">Minute(s)</option>
                </select>
                <p class="mb-0 ms-2">before</p>
            </div>
            <div class="mb-3">
                <label for="title">Notes </label>
                <textarea 
                    rows="2" 
                    class="form-control" 
                    v-model="activity.notes" 
                    placeholder="Enter Notes"
                ></textarea>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    <i class="bx bx-save"></i> Save Changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('activity-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>